module.exports = __webpack_public_path__ + "img/slim31.39b590f6.jpg";